module.exports = __webpack_public_path__ + "img/wide.e734798d.jpg";